import { render, staticRenderFns } from "./applicantPage.vue?vue&type=template&id=21aff747&scoped=true&"
import script from "./applicantPage.vue?vue&type=script&lang=js&"
export * from "./applicantPage.vue?vue&type=script&lang=js&"
import style0 from "./applicantPage.vue?vue&type=style&index=0&id=21aff747&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aff747",
  null
  
)

export default component.exports